import { RaTypography } from '@components/core/index.core'
import { Loop } from '@utilities/helpers/core.helpers'
import { translate } from '@utilities/helpers/translate.helpers'

import styles from './ra-keyfact-highlights.module.scss'

interface RaKeyfactHighlightsProps {
  highlights: string[]
}

export const RaKeyfactHighlights = ({ highlights }: RaKeyfactHighlightsProps) => {
  return (
    <li className={styles['keyfact-highlights']}>
      <RaTypography
        customClasses={styles['label']}
        component="span"
        weight="bold">
        {translate('HIGHLIGHTS')}:
      </RaTypography>
      <ul>
        {Loop(highlights, (text: string, i: number) => (
          <li
            key={i}
            className={styles['highlight']}>
            <span aria-hidden="true">✓&nbsp;</span>
            <RaTypography component="span">{text}</RaTypography>
          </li>
        ))}
      </ul>
    </li>
  )
}
